import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SquareSpace = forwardRef<SVGSVGElement, IconProps>(({ color, size = 18 }, forwardedRef) => {
  if (color) {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.03278 10.4098L10.4308 4.94574C10.7975 4.5745 11.2855 4.37037 11.8057 4.37037C12.3254 4.37037 12.8134 4.57431 13.1798 4.94554L13.6003 5.37126L14.4417 4.51964L14.0211 4.09392C13.4303 3.49587 12.6435 3.1665 11.8053 3.1665C10.9674 3.1667 10.1805 3.49606 9.58965 4.09431L4.19165 9.55822L5.03278 10.4098Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2549 6.76068L11.4096 5.91032L5.98627 11.3663C5.22467 12.1325 3.98549 12.1327 3.22409 11.3667C2.46249 10.6006 2.46249 9.35376 3.22409 8.58761L7.90393 3.87995L7.05863 3.02979L2.37898 7.73744C1.15134 8.97243 1.15134 10.9821 2.37898 12.2169C2.97259 12.814 3.76305 13.1431 4.60489 13.1431C5.44692 13.1431 6.23776 12.8139 6.83138 12.2167L12.2549 6.76068Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6207 7.78251C17.0272 7.18533 16.2368 6.85645 15.3946 6.85645C14.5525 6.85664 13.7617 7.18552 13.1681 7.7829L7.74487 13.2388L8.58979 14.0892L14.0134 8.63308C14.7751 7.86691 16.0141 7.8671 16.7756 8.63288C17.1438 9.00339 17.3467 9.49662 17.3467 10.0222C17.3467 10.5479 17.1438 11.0413 16.7756 11.4118L12.0959 16.1196L12.9412 16.9698L17.6207 12.2622C18.8485 11.0272 18.8485 9.01752 17.6207 7.78251Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9672 9.58984L9.56934 15.0539C8.81115 15.821 7.57801 15.8214 6.82021 15.0541L6.39965 14.6284L5.55835 15.48L5.97891 15.9058C6.56971 16.5038 7.35644 16.8332 8.19487 16.8332C9.03272 16.833 9.81945 16.5036 10.4104 15.9054L15.8083 10.4415L14.9672 9.58984Z"
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 22 18"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 7317">
        <path
          id="Fill-1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.03938 9.49193L11.517 2.93501C11.9571 2.48952 12.5427 2.24456 13.1668 2.24456C13.7906 2.24456 14.3761 2.48929 14.8158 2.93478L15.3204 3.44563L16.33 2.42369L15.8254 1.91283C15.1164 1.19517 14.1723 0.799927 13.1664 0.799927C12.1609 0.800159 11.2166 1.1954 10.5076 1.9133L4.03003 8.46998L5.03938 9.49193Z"
          fill="black"
        />
        <path
          id="Fill-3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.706 5.11306L12.6916 4.09263L6.18362 10.6398C5.26971 11.5592 3.78269 11.5595 2.869 10.6403C1.95509 9.72091 1.95509 8.22476 2.869 7.30537L8.48481 1.65619L7.47045 0.635986L1.85487 6.28517C0.381709 7.76716 0.381709 10.1787 1.85487 11.6605C2.56721 12.3771 3.51576 12.772 4.52597 12.772C5.5364 12.772 6.48541 12.3769 7.19775 11.6603L13.706 5.11306Z"
          fill="black"
        />
        <path
          id="Fill-5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1449 6.3393C19.4328 5.62269 18.4842 5.22803 17.4736 5.22803C16.4631 5.22826 15.5141 5.62292 14.8018 6.33977L8.29395 12.8869L9.30785 13.9073L15.8161 7.35999C16.7303 6.44058 18.2171 6.44081 19.1308 7.35975C19.5727 7.80436 19.8161 8.39623 19.8161 9.0269C19.8161 9.6578 19.5727 10.2499 19.1308 10.6945L13.5152 16.3438L14.5295 17.364L20.1449 11.715C21.6183 10.233 21.6183 7.82131 20.1449 6.3393Z"
          fill="black"
        />
        <path
          id="Fill-7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9607 8.50806L10.4832 15.065C9.5734 15.9855 8.09364 15.986 7.18428 15.0652L6.67961 14.5544L5.67004 15.5763L6.17471 16.0872C6.88368 16.8048 7.82775 17.2001 8.83387 17.2001C9.83929 17.1998 10.7834 16.8046 11.4926 16.0867L17.97 9.53L16.9607 8.50806Z"
          fill="black"
        />
      </g>
    </svg>
  )
})

export default SquareSpace
